import { staff, staffAttendance } from "../client";
const config = {
  headers: {},
  signal: null,
};
export const staffPersonal = (params) => {
  const user = {
    flag: "addFacultyProfile",
    parameters: {
      facultyPersonalInfo: params,
    },
  };
  return staff.post("/faculty/info", user);
};

export const staffEducationInformation = (params) => {
  const user = {
    flag: "addFacultyEducation",
    parameters: {
      educationList: params.educationList,
    },
  };
  return staff.post("/faculty/education", user);
};

export const staffEmploymentInformation = (params) => {
  const user = {
    flag: "addFacultyEmploymentHistory",
    parameters: {
      employmentHistoryList: params.employmentHistoryList,
    },
  };
  return staff.post("/faculty/employmentHistory", user);
};

export const staffCertificationInformation = (params) => {
  const user = {
    flag: "addFacultyCertifications",
    parameters: {
      certificationsList: params.certificationsList,
    },
  };
  return staff.post("/faculty/certificate", user);
};

export const staffAchievmentsInformation = (params) => {
  const user = {
    flag: "addAchievements",
    parameters: {
      achievementsList: params.achievementsList,
    },
  };
  return staff.post("/faculty/achievements", user);
};

export const staffInterestsInformation = (params) => {
  const user = {
    flag: "addInterests",
    parameters: {
      interestList: params,
    },
  };
  return staff.post("/faculty/interests", user);
};

export const getStaffInfo = (params) => {
  const user = {
    flag: "getFacultyInfo",
    parameters: {
      getFacultyInfo: params,
    },
  };
  return staff.post("/get/facultyInfo", user);
};

export const updateStaff = (params) => {
  const user = {
    flag: "updateFacultyProfile",
    parameters: {
      facultyPersonalInfo: params.staffPersonalInfo,
    },
  };
  return staff.post("/faculty/info", user);
};

// export const updateEducation = (params) => {
//   const user = {
//     flag: "updateFacultyProfile",
//     parameters: {
//       facultyPersonalInfo: params.staffEducationInfomartion,
//     },
//   };
//   return staff.post("/faculty/info", user);
// };

// export const updateEmployment = (params) => {
//   const user = {
//     flag: "updateFacultyProfile",
//     parameters: {
//       facultyPersonalInfo: params.staffEmploymentInformation,
//     },
//   };
//   return staff.post("/faculty/info", user);
// };

export const deleteFacultyInfo = (params) => {
  const user = {
    flag: "deleteFacultyInfo",
    parameters: {
      deleteFacultyInfo: params.deleteFacultyInfo,
    },
  };
  return staff.delete("/delete/faculty", { data: user });
};

export const deleteFacultyEducation = (params) => {
  const user = {
    flag: "deleteFacultyEducation",
    parameters: {
      deleteInfo: params,
    },
  };
  return staff.delete("/delete/faculty/edu", { data: user });
};

export const deleteFacultyEmployment = (params) => {
  const user = {
    flag: "deleteFacultyEmployment",
    parameters: {
      deleteInfo: params,
    },
  };
  return staff.delete("/delete/faculty/employment", { data: user });
};
export const deleteFacultyCertification = (params) => {
  const user = {
    flag: "deleteFacultyCertification",
    parameters: {
      deleteInfo: params,
    },
  };
  return staff.delete("/delete/faculty/certification", { data: user });
};
export const deleteFacultyAchievements = (params) => {
  const user = {
    flag: "deleteFacultyAchievements",
    parameters: {
      deleteInfo: params,
    },
  };
  return staff.delete("/delete/faculty/achievement", { data: user });
};

export const uploadProfilePic = (params) => {
  const user = {
    flag: "uploadProfilePic",
    parameters: {
      facultyProfilePic: params.facultyProfilePic,
    },
  };
  return staff.post("/faculty/upload/pic", user);
};

export const searchStaff = (params) => {
  config.signal = params.signal;

  const user = {
    flag: "facultySearch",
    parameters: {
      facultySearch: params.staffSearch,
    },
  };
  return staff.post("/faculty/search", user, config);
};

// View Faculty Information Staff Screen

export const facultySearch = (params) => {
  config.signal = params.signal;
  const user = {
    flag: "facultySearch",
    parameters: {
      facultySearch: params.data || params.staffSearch,
    },
  };
  return staffAttendance.post("/faculty/search", user, config);
};

export const getStaffAttendance = (params) => {
  const user = {
    flag: "getStaffAttendance",
    parameters: {
      staffAttendance: params,
    },
  };
  return staffAttendance.post("/search/staff/attendance", user);
};

export const getFacultyStatusConfirmed = (params) => {
  const user = {
    flag: "getFacultyStatusConfirmed",
    parameters: {
      facultySearch: params,
    },
  };
  return staffAttendance.post("/get/staff/status/confirmed", user);
};

export const getFacultyStatusDeleted = (params) => {
  const user = {
    flag: "getFacultyStatusDeleted",
    parameters: {
      facultySearch: params,
    },
  };
  return staffAttendance.post("/get/staff/status/deleted", user);
};
